import { RouteObject, Navigate } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ShopPage from '../pages/shop/page';
import ProductDetailPage from '../pages/shop/product/page';
import ConsultationsPage from '../pages/consultations/page';
import BlogPage from '../pages/blog/page';
import BlogDetailPage from '../pages/blog/detail/page';
import AboutPage from '../pages/about/page';
import ContactPage from '../pages/contact/page';
import EvilEnergyDestroyPage from '../pages/evil-energy-destroy/page';
import BlueProtectPage from '../pages/blue-protect/page';
import EvilEnergyDestroyKitPage from '../pages/evil-energy-destroy-kit/page';
import OrdersPage from '../pages/orders/page';
import OrderSuccessPage from '../pages/order-success/page';
import ReviewsPage from '../pages/reviews/page';
import FAQPage from '../pages/faq/page';
import AdminPage from '../pages/admin/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/shop', element: <ShopPage /> },
  { path: '/shop/:id', element: <ProductDetailPage /> },
  { path: '/evil-energy-destroy', element: <EvilEnergyDestroyPage /> },
  { path: '/evil-energy-protect', element: <Navigate to="/evil-energy-destroy" replace /> },
  { path: '/blue-protect', element: <BlueProtectPage /> },
  { path: '/evil-energy-destroy-kit', element: <EvilEnergyDestroyKitPage /> },
  { path: '/consultations', element: <ConsultationsPage /> },
  { path: '/orders', element: <OrdersPage /> },
  { path: '/order-success', element: <OrderSuccessPage /> },
  { path: '/reviews', element: <ReviewsPage /> },
  { path: '/blog', element: <BlogPage /> },
  { path: '/blog/:id', element: <BlogDetailPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/faq', element: <FAQPage /> },
  { path: '/admin', element: <AdminPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
